import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const EntityBuilderSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default EntityBuilderSVG;
